<div class="notification" (click)="goto(alert, $event)">
    <div class="first-row">
        <span class="event">{{ alert.event }}</span> <span class="team"> {{ alert.team }}</span>
    </div>
    <div class="second-row">
        <ng-container *ngFor="let messageInfo of alert.messageType">
            <span class="message" [ngClass]="{ highlight: messageInfo.isHighlighted }">{{ messageInfo.message }} </span>
        </ng-container>
    </div>
</div>
